angular.module("rightPaneModule")
    .directive("dblStatusAlerts", ['narrativeFilter', function(narrativeFilter) {
        return {
            restrict: "E",
            templateUrl: '/resources/right-pane/components/alerts/dbl-status-alerts.directive.html',
            scope: {
                reasonCodes: '=',
                type: '=',
                name: '='
            },
            link: function(scope, element) {
                scope.getStatus = function (code) {
                    return narrativeFilter.isWarning(code, scope.type, scope.name) ? 'NEEDS_ATTENTION' : 'PROFICIENT';
                };

                scope.getNarrativeText = function(code) {
                    return narrativeFilter(code, scope.type, scope.name);
                };
            }
        };
    }]);
